import { combineReducers } from "@reduxjs/toolkit";

import type { LanguageAction } from "entities/languages/actionTypes";
import { LanguageActionTypes } from "entities/languages/actionTypes";
import type { Language, LanguageState } from "entities/languages/types";

const initialState: LanguageState = { byId: {} };

const byId = (state = initialState.byId, action: LanguageAction): LanguageState["byId"] => {
  switch (action.type) {
    case LanguageActionTypes.FETCH_ALL_FULFILLED:
      return action.payload.languages.reduce<Record<string, Language>>(
        (accumulator, next) => ({ ...accumulator, [next.id]: { ...state[next.id], ...next } }),
        state,
      );
    default:
      return state;
  }
};

export const languagesReducer = combineReducers({ byId });
